import { use, useCallback, useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import './Home.css';
import useFetch from '../../../hooks/use-fetch';
import { request } from '../../../axiosConfig';
import { MenuItem, Select, Switch, Typography } from '@mui/material';
import CustomForm from '../CustomForm/CustomForm';



const Home = () => {
  const { get, post } = useFetch();
  const [imputationKind, setImputationKind] = useState<'fesr' | 'avvni'>('fesr')

  const [reportId, setReportId] = useState<string | null>(null);
  const [generationStatus, setGenerationStatus] = useState<'idle' | 'ongoing' | 'ready' >('idle');
  const [formData, setFormData] = useState<FormData | null>(null);
  const [isFormValid, setIsFormValid] = useState(false);


  useEffect(() => {
    if (!reportId) return;

    
    if (generationStatus !== 'ongoing') {
      setGenerationStatus('ongoing');
    }

    const interval = setInterval(async () => {
      try {
        const res = await get(`/check-status/${reportId}`);
        if (res.status === 'ready') {
          clearInterval(interval);
          setGenerationStatus('ready');
          toast.success('Elaborazione completata. Pronto per il download.');
        } else if (res.status === 'error') {
          clearInterval(interval);
          setGenerationStatus('idle');
          if (res.error.includes("Prospetto")){
            toast.error('Errore durante l\'elaborazione. Prospetto non trovato.');
          } else {
            toast.error('Errore durante l\'elaborazione.');
          }
        } else {
          setGenerationStatus('idle')
          setFormData(null)
        }
      } catch {
        clearInterval(interval);
        setGenerationStatus('idle');
        toast.error('Errore nel controllo dello stato.');
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [reportId]);


  const handleSubmit = async () => {
    if (!formData) return

    try {
      const data = await post('/process-data/', formData);
      setReportId(data.report_id);
      setGenerationStatus('ongoing');
      toast.success('Il processo di generazione è iniziato.');
    } catch {
      toast.error(`Errore durante l'invio dei file.`);
    }
  }

  const handleDownloadFile = async () => {
    if (!reportId) return;
    try {
      const response = await request.get(`/download/${reportId}`, {
        responseType: 'blob',
      });
  
      if (response.data instanceof Blob) {
        const company = formData?.get("company_name")?.toString() || "company";
        const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
        const filename = `export_${company}_${timestamp}.xlsx`;
        const file = new File(
          [response.data],
          filename,
          { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
        );
  
        const url = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = url;
        link.download = file.name;
        document.body.appendChild(link);
        link.click();
  
        URL.revokeObjectURL(url);
      }
    } catch (err) {
      console.log(err)
      toast.error('Errore durante il download.');
    }
  
    setGenerationStatus('idle');
    setFormData(null);
  };

  const handleReadyToSubmit = useCallback((formData: FormData | null, isValid: boolean) => {
    setFormData(formData);
    setIsFormValid(isValid);
  }, []);


  return (
    <div className="main-container">
    
      <div className="box">
        {/* <h1 className="title">Generazione Imputazioni</h1> */}
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'end'}}>
          <div style={{width: '20%'}}>
            <Select
              labelId="imputation-kind"
              id="demo-simple-select"
              value={imputationKind}
              label="Tipologia"
              style={{width: '100%'}}
              onChange={() => {
                setImputationKind(prev => (prev === 'fesr' ? 'avvni' : 'fesr'));
              }}
            >
              <MenuItem value={'fesr'}>FESR</MenuItem>
              <MenuItem value={'avvni'}>Avv. Nuova Impresa</MenuItem>
            </Select>
          </div>

        </div>
        <CustomForm 
          disabled={generationStatus!=='idle'} 
          onReadyToSubmit={handleReadyToSubmit}
          kind={imputationKind}
          reset={generationStatus === 'idle' && formData === null}
        />
        
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'end'}}>
          {generationStatus === 'idle' && (
            <button
              className="btn primary"
              style={{marginTop: '30px'}}
              onClick={handleSubmit}
              disabled={!isFormValid}
            >
              Invia
            </button>
          )}
  
        {generationStatus === 'ongoing' && (
          <div className="spinner-overlay">
            <div className="status-box">
              <p>Generazione in corso...</p>
              <div className="spinner"></div>
            </div>
          </div>
        )}
        {generationStatus === 'ready' && (
          <button
            className="btn primary"
            style={{marginTop: '30px'}}
            onClick={handleDownloadFile}
          >
            Scarica
          </button>
        )}
      </div>
                
    </div>          
  </div>
  );
};

export default Home;
